<template>
  <div
    v-if="properties"
    :class="['grid-editor string', properties.classes]"
    :style="properties.styles">
    <el-form :model="form"
             ref="form"
             @submit.native.prevent="$emit('submit')">
      <el-form-item prop="model">
        <el-select
          v-model="form.model"
          :filterable="filterable"
          :placeholder="properties.placeholder"
          :remote="properties.remote"
          :remote-method="remoteMethod"
          :loading="isLoading"
          :size="properties.size"
          :rules="properties.required"
          @keyup.native.prevent.esc="$emit('cancel')"
          @visible-change="(bool) => {if (!bool) $emit('submit')}"
          ref="field"
          automatic-dropdown>
          <el-option
            v-for="item in source"
            :key="item[properties.option.value]"
            :label="item[properties.option.label]"
            :value="item[properties.option.value]">
            <span
              v-if="typeof properties.option.template === 'function'"
              v-html="properties.option.template(item)"/>
            <span v-else>{{item[properties.option.label]}}</span>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { api } from '@/services/api'
export default {
  name: 'EditorSelect',
  props: {
    options: { type: Object },
    data: { type: Object, required: true },
    isEdit: { type: Boolean, default: false }
  },
  watch: {
    options: 'parserOptions',
    data: 'parserDate',
    isEdit: 'handleIsVisible'
  },
  data () {
    return {
      form: { model: '' },
      // rules: { model: [{ required: true, message: this.L10n('required'), trigger: 'blur' }] },
      source: [],
      isLoading: false,
      properties: null
    }
  },
  created () {
    this.parserOptions()
    this.parserDate()
  },
  computed: {
    filterable () {
      return this.properties.filterable || this.properties.remote
    }
  },
  methods: {
    OPTIONS () {
      return {
        // main
        field: '',
        value: '',
        required: null,
        // remote
        filterable: false,
        remote: false,
        filterTemplate: '',
        // data
        data: null,
        parser: null,
        sortBy: null,
        filter: null,
        // style
        option: {
          label: 'title',
          value: 'id',
          template: null
        },
        placeholder: this.L10n('select'),
        classes: '',
        styles: '',
        size: '',
        customBehaviour: false
      }
    },
    // Remote
    remoteMethod (value) {
      this.createSource(value)
    },
    // General Parser
    parserOptions () {
      this.properties = this.$_.merge(this.OPTIONS(), this.options)
      // set default validate rule if (required === true)
      if ([true, 'true'].includes(this.properties.required)) {
        this.properties.required = this.getValidationRule('requiredSelect')
      }
      this.createSource()
      this.setFocus()
    },
    createSource (filterValue) {
      this.isLoading = true
      let DS = this.properties
      if (typeof DS.data === 'function') {
        this.parseSource(DS.data(null, this))
      } else if (Array.isArray(DS.data)) {
        this.parseSource(DS.data)
      } else if (typeof DS.data === 'object' && DS.data) {
        let params = this.parseParams(filterValue)
        api
          .get(`${DS.data.url}`, { params })
          .then((response) => {
            this.parseSource(response.data.value)
            this.isLoading = false
          })
      } else if (typeof DS.data === 'string') {
        // this.DSPromise(DS.data).then(response => this.parseSource(response.records))
        this.APIWatch(DS.data, (response) => {
          if (!response.isLoading) this.parseSource(response.records)
          this.isLoading = response.isLoading
        })
      }
    },
    parseSource (Items) {
      let DS = this.properties
      let items = [].concat(Items)
      if (typeof DS.parser === 'function') items = DS.parser(items, this)
      if (DS.filter) {
        if (typeof DS.filter === 'function') {
          items = items.filter(item => {
            return DS.filter(item, this) === 'true'
          })
        } else {
          items = this.$_.filter(items, DS.filter)
        }
      }
      if (DS.sortBy) items = this.$_.sortBy(items, DS.sortBy)
      // set model
      this.source = items
      this.isLoading = false
      this.setFocus()
    },
    parserDate () {
      this.form.model = this.data[this.properties.field]
    },
    parseParams (filterValue) {
      let dataConfig = this.properties.data
      let filterList = []
      let filterFromInput = filterValue
        ? this.properties.filterTemplate
          ? this.checkEs6AndRun(this.properties.filterTemplate, filterValue, this)
          : `${this.properties.option.label}.contains("${filterValue}")`
        : ''
      dataConfig.filters && filterList.push(`( ${dataConfig.filters} )`)
      filterFromInput && filterList.push(filterFromInput)
      let params = {
        'select': dataConfig.selected || '',
        'filter': filterList.join(' && '),
        'take': dataConfig.take || 50
      }
      return JSON.parse(JSON.stringify(params))
    },
    setFocus () {
      setTimeout(() => {
        if (this.$refs.field) this.$refs.field.focus()
      }, 10)
    },
    // PUBLIC
    validate () {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) resolve(this.getValue())
        })
      })
    },
    getValue () {
      let result = {}
      result[this.properties.field] = this.form.model
      return result
    }
  }
}
</script>
